import React, { Component } from 'react'
import { connect } from 'react-redux'
import authSelector from '../../../selectors/authSelector'
import balanceSelector from '../../../selectors/balanceSelector'
import { FETCH_USER_BALANCE_REQUEST } from '../../../actions/actions'
import { PulseLoader } from 'halogen'
import { PriceWithWords, Credit } from '../../../helpers/utility'

const styles = {
  spinner: {
    display: 'flex',
    height: '80vh',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
}

class UserCredit extends Component {
  componentWillMount() {
    const { userId, dispatch } = this.props
    dispatch({ type: FETCH_USER_BALANCE_REQUEST, userId })
  }

  render() {
    if (this.props.balanceAsyncCall) {
      return (
        <div style={styles.spinner}>
          <PulseLoader color={'#00abde'} />
        </div>
      )
    }

    const { userBalance } = this.props,
      shouldShowCredit = Boolean(userBalance !== undefined && userBalance !== null)

    return (
      <div style={{ marginBottom: 20 }}>
        <span style={{ fontSize: 18, color: '#383de4' }}>
          <i className="fa fa-credit-card-alt" aria-hidden="true" />
        </span>

        <span style={{ marginRight: 15, fontSize: 18 }}>اعتبار فعلی: </span>

        {shouldShowCredit && userBalance === 0 ? (
          <Credit>{userBalance}</Credit>
        ) : (
          <PriceWithWords>{userBalance}</PriceWithWords>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...authSelector(state),
  ...balanceSelector(state),
})

export default connect(mapStateToProps)(UserCredit)



// WEBPACK FOOTER //
// ./src/components/common/credit/UserCredit.js